import { EmptyState as ChakraEmptyState, VStack } from '@chakra-ui/react'
import * as React from 'react'

export interface EmptyStateProps extends ChakraEmptyState.RootProps {
  title?: string
  description?: string
  icon?: React.ReactNode
  titleProps?: ChakraEmptyState.TitleProps
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  (props, ref) => {
    const { title, description, icon, children, titleProps, ...rest } = props
    return (
      <ChakraEmptyState.Root ref={ref} {...rest}>
        <ChakraEmptyState.Content>
          {icon && (
            <ChakraEmptyState.Indicator>{icon}</ChakraEmptyState.Indicator>
          )}
          {title && (
            <>
              {description ? (
                <VStack textAlign="center">
                  <ChakraEmptyState.Title {...titleProps}>
                    {title}
                  </ChakraEmptyState.Title>
                  <ChakraEmptyState.Description>
                    {description}
                  </ChakraEmptyState.Description>
                </VStack>
              ) : (
                <ChakraEmptyState.Title {...titleProps}>
                  {title}
                </ChakraEmptyState.Title>
              )}
            </>
          )}
          {children}
        </ChakraEmptyState.Content>
      </ChakraEmptyState.Root>
    )
  }
)
